// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import PropTypes from "prop-types";
import React from "react";
// Assets
import navImage from "assets/img/layout/Navbar.png";
import { MdNotificationsNone } from "react-icons/md";
import OmKaraLogo from "assets/img/layout/omkara.png";
import Quarkgenlogo from "assets/img/quarkgen-logo.png"
import { ThemeEditor } from "./ThemeEditor";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../../redux/actions/user";
export default function HeaderLinks(props) {
  const { secondary } = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");
  const loginData = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const firstLetterUppercase = (role) => {
    return role[0].toUpperCase() + role.substring(1, role.length);
  };
  return (
    <Flex className="headerContent"
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
    >
      <div className="headProfile">
      <Flex>
        <img src={Quarkgenlogo} className="omkaraLogo"></img>
        <Text
          ps="10px"
          pt="16px"
          pb="10px"
          pr="20px"
          w="100%"
          borderColor={borderColor}
          fontSize="sm"
          fontWeight="700"
          color={textColor}
        >
          <span></span>Powered by QuarkGen AI &nbsp; &nbsp;
        </Text>
      </Flex>
      
      <div className="headProfileRight">
      <Text
        ps="10px"
        pt="5px"
        // w="100%"
        mr="12px"
        borderColor={borderColor}
        fontSize="lg"
        fontWeight="700"
        color={textColor}
      >
        {firstLetterUppercase(loginData.details.role)}
      </Text>
      
      {/* <ThemeEditor navbarIcon={navbarIcon} /> */}
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: "pointer" }}
            color="white"
            name={loginData.details.userFullName}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; Hey, {loginData.details.userFullName}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            {/* <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Profile Settings</Text>
            </MenuItem> */}

            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={() => {
                dispatch(logOut());
              }}
            >
              <Text
                fontSize="sm"
                onClick={() => {
                  // dispatch(logOut());
                }}
              >
                Log out
              </Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
      </div>
      </div>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
